module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-ch-avt"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "ch-avt-modal-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('span', {
    staticClass: "ch-avt-modal-btn-close material-icons",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 box-choose-file"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập hình hiển thị")]), _c('input', {
    attrs: {
      "id": "avt",
      "name": "avt",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _c('div', {
    staticClass: "modal-footer ch-avt-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "ch-avt-btn-continue btn",
    on: {
      "click": function($event) {
        return _vm.validateChange()
      }
    }
  }, [_vm._v("Cập nhật")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('a', {
    staticClass: "ch-avt-btn-back btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Hủy")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61378ef0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/changeAvatar.vue
// module id = 1583
// module chunks = 0